module.exports = __webpack_public_path__ + "static/media/19ESCAP29.b654079d.jpg";